import ET3Div from "../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import Et3TextInput from "../../../../../core/et3-input/et3-text-input";
import Et3Margin from "../../../../../core/et3-ui/ET3Margin";
import getKhattabatBulkMessagingStore from "../../../../../stores/khattabat-stores/messaging-stores/bulk-messaging-store";

const InputField = withLiteObserverAndTheme<{ index: number }>((props) => {
  const { index } = props;
  const { fieldsInput, setFieldInput } = getKhattabatBulkMessagingStore();
  return (
    <ET3Div
      width={1200}
      height={60}
      alignItems={"center"}
      fDirection={"row"}
      style={{}}
      color={""}
      justifyContent={"space-between"}
      withShadow={false}
      isExtendable={false}
      isScrollable={false}
      onClick={() => {}}
    >
      <Et3TextInput
        size="EXTRA_LARGE"
        withShadow={false}
        placeHolder={"Type Here"}
        icon={"function"}
        label={""}
        style={{}}
        value={fieldsInput.get(index)}
        onChoose={(text: string) => {
          setFieldInput({
            index,
            text
          });
        }}
        onBlur={() => {}}
        type={"text"}
        onEnter={() => {}}
      />
      <Et3Margin top={10} bottom={0} left={0} right={0} />
    </ET3Div>
  );
});

export default InputField;
